<template>
	<modal-box @close="close" :header="$t('buttons.actions.edit_profile')" :subHeader="$t('headers.general.watch_profile')" class="watch-profile-form">
		<spinner v-if="loading"/>
		<error-box v-else-if="error" :error="error"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-text v-model="modelVirtualWatch.name" name="profile_name" :placeholder="$t('labels.general.name')" rules="required"/>
			<div class="form-group">
				<label>{{ $t('labels.general.picture') }}</label>
				<input type="file" name="file" id="file" @change="filesChange($event.target)" class="picture-file">
				<label for="file">
					<div v-if="pictureB64" class="picture-current">
						<avatar-picture :src="pictureB64" class="big rect"/>
						<div class="picture-remove" @click.stop.prevent="onPictureRemove">X</div>
					</div>
					<div v-else class="picture-empty">{{ $t('base.general.add_picture') }}</div>
				</label>
			</div>
			<input-date v-model="modelProfile.birthday" name="profile_birthday" :placeholder="$t('labels.general.birthdate')" rules="required"/>
			<input-select v-model="modelProfile.blood_type" :options="bloodTypes" name="profile_blood_type" :placeholder="$t('labels.general.blood_type')" rules="required"/>
			<input-text v-model="modelProfile.height" name="profile_height" :placeholder="$t('labels.general.height')" rules="integer"/>
			<input-text v-model="modelProfile.weight" name="profile_weight" :placeholder="$t('labels.general.weight')" rules="integer"/>
			<input-select v-model="modelProfile.gender" :options="genderTypes" name="profile_gender" :placeholder="$t('labels.general.gender')"/>
			<error-box v-if="form.error" :error="form.error"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</modal-box>
</template>

<script>
import generateBase64Picture from '@/utils/generateBase64Picture'
import AvatarPicture from '@/components/avatars/AvatarPicture'
export default {
	components: {
		AvatarPicture
	},
	props: [
		'user_uid',
		'watch_id',
		'data'
	],
	data () {
		return {
			loading: false,
			error: null,
			modelVirtualWatch: {
				name: '',
				picture: ''
			},
			modelProfile: {
				birthday: '',
				blood_type: '',
				height: '',
				weight: '',
				gender: ''
			},
			form: {
				loading: false,
				error: ''
			},
			bloodTypes: [
				{ value: 'O-', text: 'O-' },
				{ value: 'O+', text: 'O+' },
				{ value: 'A-', text: 'A-' },
				{ value: 'A+', text: 'A+' },
				{ value: 'B-', text: 'B-' },
				{ value: 'B+', text: 'B+' },
				{ value: 'AB-', text: 'AB-' },
				{ value: 'AB+', text: 'AB+' }
			],
			genderTypes: [
				{ value: 'M', text: 'M' },
				{ value: 'F', text: 'F' },
			],
			pictureUid: '',
			pictureB64: ''
		}
	},
	computed: {
		picture () {
			return this.$store.getters.getWatchPicture(this.watch_id)
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.submit()
				})
		},
		submit () {
			this.form.loading = true
			Promise.all([this.editVirtualWatch(), this.editProfile()])
				.then(response => {
					this.$log.info('watch profile', 'submit OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error('watch profile', 'profile.get ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		},
		close (reload = false) {
			this.$emit('close', { reload })
		},
		editVirtualWatch () {
			return this.$api.watches.edit(this, this.user_uid, this.watch_id, this.modelVirtualWatch)
				.then(response => {
					this.$log.info('watch profile', 'watches.edit OK', response)()
					return response
				}).catch(error => {
					this.$log.error('watch profile', 'watches.edit ERROR', error)()
				})
		},
		editProfile () {
			const model = { ...this.modelProfile }
			Object.keys(model).forEach(key => (!model[key]) && delete model[key])
			return this.$api.profile.edit(this, this.user_uid, this.watch_id, model)
				.then(response => {
					this.$log.info('watch profile', 'profile.edit OK', response)()
					return response
				}).catch(error => {
					this.$log.error('watch profile', 'profile.edit ERROR', error)()
				})
		},
		getProfile () {
			this.loading = true
			this.$api.profile.get(this, this.user_uid, this.watch_id)
				.then(response => {
					this.$log.info('watch profile', 'profile.get OK', response)()
					this.modelVirtualWatch = {
						name: response.body.name,
						picture: this.data.data.picture_uid
					}
					this.modelProfile = {
						birthday: response.body.birthday,
						blood_type: response.body.blood_type,
						height: response.body.height,
						weight: response.body.weight,
						gender: response.body.gender
					}
					this.pictureB64 = this.picture
				}).catch(error => {
					this.$log.error('watch profile', 'profile.get ERROR', error)()
					this.error = error
				}).finally(() => {
					this.loading = false
				})
		},
		filesChange (target) {
			Array.from(Array(target.files.length).keys())
				.map(i => {
					this.uploadFile(target.files[i])
				})
		},
		uploadFile (file) {
			this.$api.files.upload(this, this.user_uid, null, file)
				.then(response => {
					this.$log.info('watch profile', 'files.upload OK', response)()
					this.downloadFile(response.body.uid)
					this.modelVirtualWatch.picture = response.body.uid
				}).catch(error => {
					this.$log.error('watch profile', 'files.upload ERROR', error)()
					this.error = error
				})
		},
		downloadFile (file_uid) {
			this.downloading = true
			Promise.all([this.getPicture(file_uid), this.getPictureMetadata(file_uid)])
				.then(([picture, metadata]) => {
					this.$log.info('watch profile', 'downloadFile() OK', picture, metadata)()
					this.pictureUid = metadata.uid
					this.pictureB64 = generateBase64Picture(picture, metadata.extension)
				}).catch(error => {
					this.$log.error('watch profile', 'downloadFile() ERROR', error)()
				}).finally(() => {
					this.downloading = false
				})
		},
		getPicture (file_uid) {
			return this.$api.files.get(this, this.user_uid, this.watch_id, file_uid)
				.then(response => {
					this.$log.info('watch profile', 'files.get OK', response)()
					return response.body
				}).catch(error => {
					this.$log.error('watch profile', 'files.get ERROR', error)()
					this.error = error
				})
		},
		getPictureMetadata (file_uid) {
			return this.$api.files.getMetadata(this, this.user_uid, this.watch_id, file_uid)
				.then(response => {
					this.$log.info('watch profile', 'files.getMetadata OK', response)()
					return response.body
				}).catch(error => {
					this.$log.error('watch profile', 'files.getMetadata ERROR', error)()
					this.error = error
				})
		},
		onPictureRemove () {
			this.modelVirtualWatch.picture = ''
			this.pictureB64 = ''
		}
	},
	created () {
		this.getProfile()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/profile/WatchProfileEdit.vue